export default __webpack_public_path__ + "static/media/lines.d5d572fa.svg";